import { useEffect, useRef } from "react";
import { Card, message } from "antd";
import { useNavigate } from "react-router-dom";
import useUserContext from "../../hooks/useUserContext";
import { CreateV2Automation } from "../../api/v2/automations";
import Loader from "../../components/loader/Loader";

export default function AutomationTreeCreatePage() {
    const navigate = useNavigate();
    const { selectedDomain } = useUserContext();
    const requestedRef = useRef(false);

    useEffect(() => {
        if (!selectedDomain || requestedRef.current) return;
        requestedRef.current = true;

        const run = async () => {
            const res = await CreateV2Automation(selectedDomain, {
                name: "New Automation",
                description: null,
                active: 1,
            });

            if (!res.ok || !res.data?.id) {
                message.error(res.error || "Failed creating automation");
                navigate("/automations-pro");
                return;
            }

            navigate(`/automations-pro/${res.data.id}/tree`, { replace: true });
        };

        run();
    }, [navigate, selectedDomain]);

    return (
        <Card>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 220 }}>
                <Loader size={72} />
            </div>
        </Card>
    );
}
